export default {
    hashCode(s) {
      return s.split('').reduce((prevHash, currVal) =>
        (((prevHash << 5) - prevHash) + currVal.charCodeAt(0))|0, 0);
    },
      getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    getRandomFloat(min, max) {
        const val = Math.random() * (max - min) + min;
        return Math.round(val * 10**4) / 10**4
    },
    highlightStyles (type, column) {
      return this[type].indexOf(column) !== -1 ?
        `background-color: ${this.highlightColor}; color: ${this.fontColor};`:
        ''
    },
}